let wares = [
    {
        path: 'wares',
        name: '商品管理',
        redirect: 'wares/goods',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'goods',
                component: () => import("@/views/admin/marketing/wares/waresG/index.vue"),
                name: '商品管理',
                meta: {
                    hidden: true,
                    key: 2001,
                    // hidden: true,
                    // key: 2001,
                    // isShow:false
                },
            },
            {
                path: 'release/:id?',
                component: () => import("@/views/admin/marketing/wares/product-release/index.vue"),
                name: '商品发布',
                meta: {
                    hidden: true,
                    key: 2001,
                    isShow:false
                },
            },
            {
                path: 'classify',
                component: () => import("@/views/admin/marketing/wares/classify/index.vue"),
                name: '分类管理',
                meta: {
                    hidden: true,
                    key: 2002,
                },
            },
            {
                path: 'brand',
                component: () => import("@/views/admin/marketing/wares/brand/index.vue"),
                name: '品牌管理',
                meta: {
                    hidden: true,
                    key: 2003,
                },
            },
            {
                path: 'type',
                component: () => import("@/views/admin/marketing/wares/type/index.vue"),
                name: '类型管理',
                meta: {
                    hidden: true,
                    key: 2004,
                },
            },
            {
                path: 'consult',
                component: () => import("@/views/admin/marketing/wares/consult/index.vue"),
                name: '咨询管理',
                meta: {
                    hidden: true,
                    key: 2006,
                },
            },
            {
                path: 'comment',
                component: () => import("@/views/admin/marketing/wares/comment/index.vue"),
                name: '评论管理',
                meta: {
                    hidden: true,
                    key: 2007,
                },
            },
            {
                path: 'unit',
                component: () => import("@/views/admin/marketing/wares/unit/index.vue"),
                name: '计量单位管理',
                meta: {
                    hidden: true,
                    key: 2008,
                },
            },

        ]
    }
]

let community = [
    {
        path: 'community',
        name: '社区管理',
        redirect: 'community/order',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'shop',
                component: () => import("@/views/admin/marketing/shop/shopG/index.vue"),
                name: '店铺管理',
                meta: {
                    hidden: true,
                    key: 5001,
                },
            },
            {
                path: 'shop/details/:id/:entry?',
                component: () => import("@/views/admin/marketing/shop/shopG/details/index.vue"),
                name: '店铺详情',
                meta: {
                    hidden: true,
                    key: 5001,
                    isShow:false
                },
            },
            {
                path: 'goods-package',
                component: () => import("@/views/admin/marketing/shop/goods-package/index.vue"),
                name: '店铺套餐',
                meta: {
                    hidden: true,
                    key: 5002,
                },
            },

            {
                path: 'goods-manage',
                component: () => import("@/views/admin/marketing/shop/goods-manage/index.vue"),
                name: '门店管理',
                meta: {
                    hidden: true,
                    key: 5006,
                },
            },
            {
                path: 'goods-manage/shop/:id',
                component: () => import("@/views/admin/marketing/shop/goods-manage/goods/index.vue"),
                name: '店铺商品管理',
                meta: {
                    hidden: true,
                    key: 5006,
                    isShow:false
                },
            },
            // {
            //     path: 'financial',
            //     component: () => import("@/views/admin/marketing/shop/financial-manage/index.vue"),
            //     name: '财务管理',
            //     meta: {
            //         hidden: true,
            //         key: 5003,
            //     },
            // },
            {
                path: 'financial/setdetail/:id/:shopid?',
                component: () => import("@/views/admin/marketing/shop/financial-manage/setdetail/index.vue"),
                name: '结算列表详情',
                meta: {
                    hidden: true,
                    isShow:false
                },
            },
            {
                path: 'financial/orders/:id?',
                component: () => import("@/views/admin/marketing/shop/financial-manage/orders/index.vue"),
                name: '待结算列表详情',
                meta: {
                    hidden: true,
                    isShow:false
                },
            },
            // {
            //     path: 'withdrawal',
            //     component: () => import("@/views/admin/marketing/shop/withdrawal-manage/index.vue"),
            //     name: '商家提现管理',
            //     meta: {
            //         hidden: true,
            //         key: 5005,
            //     },
            // },
        ]
    }
]


let trade = [
    {
        path: 'trade',
        name: '交易管理',
        redirect: 'trade/order',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'order',
                component: () => import("@/views/admin/marketing/trade/order/index.vue"),
                name: '订单管理',
                meta: {
                    hidden: true,
                    key: 3001,
                },
                redirect: 'order/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/admin/marketing/trade/order/list/index.vue"),
                        name: 'admin订单列表',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'details/:id',
                        component: () => import("@/views/admin/marketing/trade/order/details/index.vue"),
                        name: 'admin订单详情',
                        meta: {
                            hidden: true,
                        },
                    },
                ]
            },
            {
                path: 'refund',
                component: () => import("@/views/admin/marketing/trade/refund/index.vue"),
                name: '退款处理',
                meta: {
                    hidden: true,
                    key: 3002,
                },
            },
            {
                path: 'goodsRejected',
                component: () => import("@/views/admin/marketing/trade/goodsRejected/index.vue"),
                name: '退货处理',
                meta: {
                    hidden: true,
                    key: 3009,
                },
            },
            {
                path: 'evaluate',
                component: () => import("@/views/admin/marketing/trade/evaluate/index.vue"),
                name: '交易评价',
                meta: {
                    hidden: true,
                    key: 3003,
                },
            },
            {
                path: 'complaint',
                component: () => import("@/views/admin/marketing/trade/complaint/index.vue"),
                name: '客诉管理',
                meta: {
                    hidden: true,
                    key: 3004,
                },
            },
            {
                path: 'payment',
                component: () => import("@/views/admin/marketing/trade/payment/index.vue"),
                name: '支付方式',
                meta: {
                    hidden: true,
                    key: 3005,
                },
            },
            {
                path: 'express',
                component: () => import("@/views/admin/marketing/trade/express/index.vue"),
                name: '快递单模板',
                meta: {
                    hidden: true,
                    key: 3006,
                },
            },
            {
                path: 'trade',
                component: () => import("@/views/admin/marketing/trade/tradeG/index.vue"),
                name: '交易配置',
                meta: {
                    hidden: true,
                    key: 3007,
                },
            },
            {
                path: 'invoice',
                component: () => import("@/views/admin/marketing/trade/invoice/index.vue"),
                name: '发票管理',
                meta: {
                    hidden: true,
                    key: 3008,
                },
            },
            {
                path: 'writeoff',
                component: () => import("@/views/admin/marketing/trade/writeoff/index.vue"),
                name: '核销管理',
                meta: {
                    hidden: true,
                    key: 3010,
                },
            },
            // {
            //     path: 'settleaccounts',
            //     component: () => import("@/views/admin/marketing/trade/settleaccounts/index.vue"),
            //     name: '结算管理',
            //     meta: {
            //         hidden: true,
            //         key: 3020,
            //     },
            // },

        ]
    }
]



let census = [
    {
        path: 'census',
        name: '资产统计',
        redirect: 'census/member',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'member',
                component: () => import("@/views/admin/marketing/statistics/member/index.vue"),
                name: '会员统计',
                meta: {
                    hidden: true,
                    key: 6002,
                },
            },
            {
                path: 'shop',
                component: () => import("@/views/admin/marketing/statistics/shop/index.vue"),
                name: '店铺统计',
                meta: {
                    hidden: true,
                    key: 6003
                },
            },
            {
                path: 'commodity',
                component: () => import("@/views/admin/marketing/statistics/commodity/index.vue"),
                name: '商品统计',
                meta: {
                    hidden: true,
                    key: 6004,
                },
            },
            {
                path: 'deal',
                component: () => import("@/views/admin/marketing/statistics/deal/index.vue"),
                name: '交易统计',
                meta: {
                    hidden: true,
                    key: 6005,
                },
            },
        ]
    }
]

let marketing = [
    {
        path: 'marketing',
        name: '营销管理',
        redirect: 'marketing/member',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [

            // {
            //     path: 'home',
            //     component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/home/index.vue"),
            //     name: 'home',
            //     meta: {
            //         hidden: true,
            //     },
            // },
            // {
            //     path: 'coupon',
            //     component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/coupon/index.vue"),
            //     name: '优惠卷',
            //     meta: {
            //         hidden: true,
            //     },
            // },
            {
                path: 'limit-buy',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/limit-buy/index.vue"),
                name: '限时购',
                meta: {
                    hidden: true,
                },
            },
            // {
            //     path: 'compose',
            //     component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/compose/index.vue"),
            //     name: '组合购',
            //     meta: {
            //         hidden: true,
            //     },
            // },
            // {
            //     path: 'full-reduction',
            //     component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/full-reduction/index.vue"),
            //     name: '满额减',
            //     meta: {
            //         hidden: true,
            //     },
            // },
            {
                path: 'collage',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/collage/index.vue"),
                name: '拼团',
                meta: {
                    hidden: true,
                },
            },
            // {
            //     path: 'allowance',
            //     component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/allowance/index.vue"),
            //     name: '代金红包',
            //     meta: {
            //         hidden: true,
            //     },
            // },


            {
                path: 'signin',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/signin/index.vue"),
                name: '签到',
                meta: {
                    hidden: true,
                },
            },
            {
                path: 'draw-pink',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/draw-pink/index.vue"),
                name: '吸粉红包',
                meta: {
                    hidden: true,
                },
            },
            {
                path: 'new-gift',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/new-gift/index.vue"),
                name: '新人礼包',
                meta: {
                    hidden: true,
                },
            },
            {
                path: 'guaguale',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/guaguale/index.vue"),
                name: '刮刮卡',
                meta: {
                    hidden: true,
                },
                redirect: 'guaguale/index',
                children: [
                    {
                        path: 'index',
                        component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/guaguale/default/index.vue"),
                        name: '刮刮乐管理',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'details/:id',
                        component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/guaguale/winning-details/index.vue"),
                        name: '刮刮乐中奖详情',
                        meta: {
                            hidden: true,
                        },
                    },
                ]
            },
            {
                path: 'turntable',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/turntable/index.vue"),
                name: '幸运大转盘',
                meta: {
                    hidden: true,
                },
                redirect: 'turntable/index',
                children: [
                    {
                        path: 'index',
                        component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/turntable//default/index.vue"),
                        name: '大转盘管理',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'details/:id',
                        component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/turntable/winning-details/index.vue"),
                        name: '大转盘中奖详情',
                        meta: {
                            hidden: true,
                        },
                    },
                ]
            },
            {
                path: 'gift',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/gift/index.vue"),
                name: '礼品管理',
                meta: {
                    hidden: true,
                },
            },
            {
                path: 'gift-convert',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/gift-convert/index.vue"),
                name: '礼品兑换列表',
                meta: {
                    hidden: true,
                },
            },
            {
                path: 'recharge-gift',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/recharge-gift/index.vue"),
                name: '充值赠送',
                meta: {
                    hidden: true,
                },
            },
            {
                path: 'special',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/special/index.vue"),
                name: '专题管理',
                redirect: 'special/list',
                meta: {
                    hidden: true,
                    key: 9010,
                },
                children:[
                    {
                        path: 'list',
                        component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/special/list/index.vue"),
                        name: '专题列表',
                        meta: {
                            hidden: true,
                            current: "list",
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/special/multi/index.vue"),
                        name: '专题多功能',
                        meta: {
                            hidden: true,
                            current: "multi",
                        },
                    },
                ]
            },
        ]
    }
]
let applet = [
    {
        path: 'Applet',
        name: '小程序',
        // redirect: 'Applet/member',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children:[
            {
                path: 'WxGoods',
                component: () => import("@/views/admin/marketing/applet/wx-goods/index.vue"),
                name: '商品配置',
                meta: {
                    hidden: true,
                    key: 13002,
                },
            },
            {
                path: 'WxHome',
                component: () => import("@/views/admin/marketing/applet/wx-home/index.vue"),
                name: '首页配置',
                meta: {
                    hidden: true,
                    key: 13001,
                },
            },

            {
                path: 'WxType',
                component: () => import("@/views/admin/marketing/applet/wx-type/index.vue"),
                name: '商品类型配置',
                meta: {
                    hidden: true,
                    key: 13004,
                },
            },
            {
                path: 'prefecture',
                component: () => import("@/views/admin/marketing/applet/prefecture/index.vue"),
                name: '专区配置',
                meta: {
                    hidden: true,
                    key: 13005,
                },
            },

        ]
    }
]

let website = [
    {
        path: 'Website',
        name: '通知公告',
        // redirect: 'Applet/member',
        component: () => import("@/views/admin/marketing/website/index.vue"),
        children:[
              {
                path: 'Posts',
                component: () => import("@/views/admin/marketing/website/posts/index.vue"),
                name: '公告管理',
                meta: {
                  hidden: true,
                  key:7002,
                },
              },
              {
                path: 'Categories',
                component: () => import("@/views/admin/marketing/website/categories/index.vue"),
                name: '咨询管理',
                meta: {
                  hidden: true,
                  key:7003,
                },
              }
        ]
    }
]

export const digit = [
    {
        path: '/digit',
        name: '营销系统',
        redirect: '/digit/wares',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...wares,//商品
            ...community,//社区
            ...trade,//交易
            ...census,//资产统计
            ...marketing,//营销
            ...applet,//小程序
            ...website,//网站
            {
              path: 'purchase',
              name: '批采订货管理',
              component: () => import("@/views/admin/marketing/purchase/index.vue"),
              meta: {
                hidden: true,
                key:2009,
              },
            },
            {
              path: 'purchase-order',
              name: '批采订单管理',
              component: () => import("@/views/admin/marketing/purchase-order/index.vue"),
              meta: {
                hidden: true,
                key:2010,
              },
            }
        ]
    },

]
